import { CircularProgress, Grid } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import NumberFormat from 'react-number-format';
import ToolTip from '../../../components/Tooltip/Tooltip';
import classes from '../UnitEconomics.module.css';

const LtvCac = props => {
	const { churn, isLoading, clasificacion, mrrMensual, mrrAnual } = props;

	const percentChurn = churn.percentNChurn;
	const [ticketPromedio, setTicketPromedio] = useState(0);
	//const [booleanClasificacion, setBooleanClasificacion] = useState(true);
	const [CAC, setCAC] = useState();
	const [monthYear, setMonthYear] = useState('');

	const formatDate = dateToTransform => {
		var date = new Date(dateToTransform);

		var monthNames = [
			'Enero',
			'Febrero',
			'Marzo',
			'Abril',
			'Mayo',
			'Junio',
			'Julio',
			'Agosto',
			'Septiembre',
			'Octubre',
			'Noviembre',
			'Diciembre',
		];

		//var day = date.getUTCDate();
		var monthIndex = date.getUTCMonth();
		var year = date.getUTCFullYear();

		return monthNames[monthIndex] + ' ' + year;
	};

	useEffect(() => {
		if (isLoading === false) {
			setMonthYear(formatDate(churn.initialDate));
		}
	}, [isLoading, churn.initialDate]);

	useEffect(() => {
		const updateHook = async () => {
			if (isLoading === false) {
				setTicketPromedio((mrrMensual.mrr + mrrAnual.mrrPlanAnual) / churn.nEmpresasActuales);

				/* if (clasificacion !== '0') {
					setBooleanClasificacion(true);
				} else {
					setBooleanClasificacison(false);
				} */
			}
		};
		updateHook();
	}, [isLoading, clasificacion, mrrMensual, churn, mrrAnual]);

	return (
		<React.Fragment>
			<Grid item xs={12}>
				<Grid container spacing={2}>
					<Grid item xs={6}>
						<div className={classes.cardLTVCAC}>
							<ToolTip
								text={
									'Lifetime Value se utiliza para determinar el valor que un cliente aporta a un negocio durante toda la vida útil de la empresa. El CAC es el coste de adquisición de un cliente y debe ser menor que el LTV.'
								}
							/>
							<div className={classes.headerTitle}>LTV</div>
							<div className={classes.date}>{monthYear}</div>
							{isLoading ? (
								<CircularProgress />
							) : (
								<div>
									<div className={classes.percentChurn}>
										Ticket Promedio:
										<NumberFormat
											value={ticketPromedio}
											displayType={'text'}
											thousandSeparator={true}
											prefix={'US$'}
											decimalScale={0}
										/>
									</div>
									<br></br>

									<div className={classes.number}>
										<NumberFormat
											value={ticketPromedio * (1 / percentChurn)}
											displayType={'text'}
											thousandSeparator={true}
											prefix={'US$'}
											decimalScale={0}
										/>
									</div>
									<table align="center">
										<tbody>
											<tr>
												<td>
													<div className={classes.headerTitle}>CAC</div>
												</td>
												<td>
													<input
														className={classes.input}
														type="text"
														placeholder="Ingresa un Valor $"
														value={CAC}
														onChange={event => setCAC(event.target.value)}
													/>
												</td>
											</tr>
										</tbody>
									</table>

									{clasificacion ? <div></div> : <div></div>}
								</div>
							)}
						</div>
					</Grid>

					<Grid item xs={6}>
						<div className={classes.cardLTVCAC}>
							<ToolTip
								text={
									'La relación LTV / CAC compara el valor de un cliente a lo largo de su vida útil, en comparación con el costo de adquirirlos. \
                                    Si la relación LTV / CAC es menor que 1.0, la compañía está destruyendo el valor, si la relación es mayor que 1.0 puede \
                                    estar creando valor, pero se requiere más análisis. En términos generales, una relación superior a 3.0 se considera "buena".'
								}
							/>
							<div className={classes.headerTitle}>LTV/CAC Ratio</div>
							<div className={classes.date}>{monthYear}</div>
							<div className={(ticketPromedio * (1 / percentChurn)) / CAC > 3 ? classes.ltvCacGreen : classes.ltvCacRed}>
								<NumberFormat
									value={(ticketPromedio * (1 / percentChurn)) / CAC}
									displayType={'text'}
									thousandSeparator={true}
									decimalScale={2}
								/>
							</div>
						</div>
					</Grid>
				</Grid>
			</Grid>
		</React.Fragment>
	);
};

export default React.memo(LtvCac);
